
import React from 'react';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

// Define the chart configuration for admin dashboard
export const adminChartConfig = {
  users: {
    label: 'Neue Benutzer',
    color: '#18B08D', 
  },
  logins: {
    label: 'Anmeldungen',
    color: '#7E69AB',
  },
  credits_used: {
    label: 'Genutzte Credits',
    color: '#3B82F6',
  },
};

type AdminChartProps = {
  data: any[];
  height?: number;
  children: React.ReactNode;
};

export const AdminChart: React.FC<AdminChartProps> = ({ 
  data, 
  height = 350, 
  children 
}) => {
  // We need to ensure children is a ReactElement
  // By wrapping it in a Fragment if it's not already a single element
  const childElement = React.isValidElement(children) 
    ? children 
    : <React.Fragment>{children}</React.Fragment>;

  return (
    <div style={{ height: `${height}px` }}>
      <ChartContainer
        config={adminChartConfig}
        className="h-full"
      >
        {childElement}
      </ChartContainer>
    </div>
  );
};
